// 45-B, paczka PP2 — podglad: zamiany terminow, kolejnosc jak w serii (C0, KONTRAKTY 2026-09-24).
// Poddrzewo `appCampaigns.p45.*`: ten plik edytuje TYLKO jego paczka; klucze PL i EN rownoczesnie.
// Teksty: MAPA 45-B „Teksty PL / EN” (order.*, move.*); zero zdan objasniajacych (regula 8).
export const appCampaignsP45 = {
  p45: {
    order: {
      label: 'Order',
      series: 'as in the series',
      random: 'random',
    },
    move: {
      action: 'Move',
      swap: 'Swap',
      chosen: 'Selected',
      confirm: 'Swap times',
      carrying: 'moving',
      region: 'Post being moved',
      cancel: 'Stop moving',
      handle: 'Drag onto another post: {title}',
      done: 'Swapped · {a} and {b}',
      reason: {
        limit: 'daily limit',
        gap: 'too close',
        window: 'outside account hours',
        plan: 'not in the plan',
      },
    },
  },
}
